// frontend/packages/business-console/src/services/contentVersionApi.js
//
// API client for content versioning endpoints (autosave, versions, trash).

const BASE = "/v2";

async function apiFetch(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { "Content-Type": "application/json", ...options.headers },
    ...options,
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(data?.error || `Request failed: ${res.status}`);
  }
  return data;
}

export async function autosaveContent(filePath, content) {
  return apiFetch("/content/versions/save", {
    method: "POST",
    body: JSON.stringify({ filePath, content }),
  });
}

export async function listVersions(filePath, limit = 20) {
  const params = new URLSearchParams({ filePath, limit: String(limit) });
  return apiFetch(`/content/versions?${params}`);
}

export async function getVersion(blobPath) {
  const params = new URLSearchParams({ blobPath });
  return apiFetch(`/content/versions/get?${params}`);
}

export async function moveToTrash(filePath, content) {
  return apiFetch("/content/trash", {
    method: "POST",
    body: JSON.stringify({ filePath, content }),
  });
}

export async function listTrashItems(limit = 20) {
  const params = new URLSearchParams({ limit: String(limit) });
  return apiFetch(`/content/trash?${params}`);
}

export async function getTrashItem(blobPath) {
  const params = new URLSearchParams({ blobPath });
  return apiFetch(`/content/trash/get?${params}`);
}
